<template>
  <div>
    <div id="container" class="library_st">
      <!-- Location START -->
      <div class="location_wrap">
        <div class="location">
          <button
            v-show="!isSidebarOpen"
            type="button"
            class="btn_open_snb"
            @click="openSidebar"
          >
            {{ $t('views.library.mynotes.743') }}
          </button>
          <span>{{ $t('views.library.mynotes.8968') }}</span>
          <span class="svg_next">></span>
          <span>노트</span>
          <span class="svg_next">></span>

          <div v-on-clickaway="closeListMenu" class="current">
            <div class="select_area">
              <div :class="{ active: isListMenuOpen }" class="select_item">
                <button
                  type="button"
                  class="select_option"
                  @click.prevent.stop="toggleListMenu"
                >
                  <!-- TODO: @Stan Change this to be displayed when notes shared with the user are displayed  -->
                  <template v-if="$route.path === 'my_notes/shared'">
                    <span class="txt">{{
                      $t('views.library.mynotes.4028')
                    }}</span
                    ><span class="arrow blind">열기</span>
                  </template>
                  <template v-else>
                    <span class="txt">{{
                      $t('views.library.mynotes.786')
                    }}</span
                    ><span class="arrow blind">열기</span>
                  </template>
                </button>
                <!-- List Items -->
                <ul class="select_list">
                  <li @click="toggleListMenu">
                    <router-link :to="{ name: 'my_notes' }">{{
                      $t('views.library.mynotes.7682')
                    }}</router-link>
                  </li>
                  <!-- TODO: @Stan Change to correct params -->
                  <li @click="toggleListMenu">
                    <router-link :to="{ name: 'my_notes', params: 'shared' }">{{
                      $t('views.library.mynotes.8144')
                    }}</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="eplist_sort">
          <ul v-if="!isDeleteNoteModeEnabled" class="board_sort">
            <li>
              <a
                tabindex="0"
                :class="[activeFilter === 1 ? 'active' : '']"
                @click="filterNotes('purchaseDate'), (activeFilter = 1)"
                @keypress.enter="
                  filterNotes('purchaseDate'), (activeFilter = 1)
                "
                ><span>{{ $t('views.library.mynotes.7934') }}</span></a
              >
            </li>
            <li>
              <a
                tabindex="0"
                :class="[activeFilter === 2 ? 'active' : '']"
                @click="filterNotes('lastOpened'), (activeFilter = 2)"
                @keypress.enter="filterNotes('lastOpened'), (activeFilter = 2)"
                ><span>{{ $t('views.library.mynotes.1078') }}</span></a
              >
            </li>
            <!-- FIXME: Not sure if 'popular' makes sense here. Needs checking with 기획 team -->
            <li>
              <a
                tabindex="0"
                :class="[activeFilter === 3 ? 'active' : '']"
                :to="{ name: 'my_notes', params: 'popular' }"
                @click="filterNotes('lastOpened'), (activeFilter = 3)"
                @keypress.enter="filterNotes('lastOpened'), (activeFilter = 3)"
                ><span>인기</span></a
              >
            </li>
          </ul>
          <!-- DELETE SUB MENU -->
          <div class="btn_wrap">
            <div v-if="isDeleteNoteModeEnabled" class="library_option cancel">
              <button type="button" class="btn" @click="endSelectMode">
                <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
              </button>
              <div class="guide_txt">
                <p>{{ $t('views.library.mynotes.4338') }}</p>
              </div>
            </div>
            <div class="library_option delete">
              <button
                v-if="!isDeleteNoteModeEnabled"
                type="button"
                class="btn"
                @click="startSelectMode"
              >
                <span class="c_icon"></span
                ><span class="an_t">{{
                  $t('library.deletemodal.delete')
                }}</span>
              </button>
              <button
                v-if="isDeleteNoteModeEnabled"
                type="button"
                class="btn"
                @click="toggleDeleteModal"
              >
                <span class="c_icon"></span
                ><span class="an_t">{{
                  $t('library.deletemodal.delete')
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Location END -->

      <!-- 기본 서재 -->
      <div class="section full">
        <div class="inner">
          <div class="eplist note item_columns_grid">
            <div>
              <ul class="item_list">
                <!-- ************ -->
                <!-- MY NOTE ITEMS -->
                <!-- ************ -->
                <li v-for="(note, id) in notes" :key="id">
                  <!-- TODO: @Stan Should be a component called BaseNote which switches to 'active' class when instance is selected -->
                  <div class="cover_wrap" :class="{ best: note.isBest }">
                    <router-link
                      :to="{ name: 'my_note_detail', params: 'note.id' }"
                      class="thum_wrap"
                    >
                      <img :src="note.img" alt="책제목" />
                    </router-link>
                    <!-- Select book for deletion -->
                    <div
                      class="select_book"
                      :class="{ hidden: !isSelectMode, active: selected }"
                    >
                      <button
                        type="button"
                        class="btn_select_book"
                        @click="selectThisBook"
                      >
                        {{ $t('views.library.mynotes.3524') }}
                      </button>
                    </div>
                  </div>
                  <div class="info_wrap">
                    <p>
                      <span class="meta_author">{{ note.noteAuthor }}</span>
                    </p>
                  </div>
                </li>
              </ul>

              <!-- TODO: Add pagination -->
              <div class="board_pagemove_wrap">
                <div class="board_pagemove">
                  <a href="javascript:void(0)" class="first disable hidden"
                    ><span>{{ $t('common.ui.first') }}</span></a
                  >
                  <a href="javascript:void(0)" class="prev"
                    ><span>{{ $t('common.ui.previous') }}</span></a
                  >
                  <ul>
                    <li class="on"><a href="javascript:void(0)">1</a></li>
                    <li><a href="javascript:void(0)">2</a></li>
                    <li><a href="javascript:void(0)">3</a></li>
                    <li class="hidden"><a href="javascript:void(0)">4</a></li>
                    <li class="hidden"><a href="javascript:void(0)">5</a></li>
                    <li class="hidden"><a href="javascript:void(0)">6</a></li>
                    <li class="hidden"><a href="javascript:void(0)">7</a></li>
                    <li class="hidden"><a href="javascript:void(0)">8</a></li>
                    <li class="hidden"><a href="javascript:void(0)">9</a></li>
                    <li class="hidden"><a href="javascript:void(0)">10</a></li>
                  </ul>
                  <a href="javascript:void(0)" class="next"
                    ><span>{{ $t('common.ui.next') }}</span></a
                  >
                  <a href="javascript:void(0)" class="end hidden">
                    <span>{{ $t('views.library.mynotes.1439') }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DELETE CONFIRM MODAL -->
    <transition name="modal-fade">
      <!-- TODO: @Stan, delete modal should only open @click of 삭제 if a note has been selected -->
      <Modal v-if="showDeleteModal" @close="toggleDeleteModal">
        <div class="ly_pop_wrap fix">
          <div class="ly_pop_content ly_pop_libr">
            <div class="ly_pop_head">
              <h2>{{ $t('views.library.mynotes.2733') }}</h2>
              <a class="btn_ly_close svg_close" @click="toggleDeleteModal">
                <span>{{ $t('library.deletemodal.close') }}</span>
              </a>
            </div>
            <div class="ly_inner">
              <div class="editer_libr text-center">
                <p>{{ $t('views.library.mynotes.3994') }}</p>
                <div class="editer_form"></div>
              </div>
              <div class="btn_wrap text-center">
                <button
                  type="submit"
                  class="box_btn dull"
                  @click="toggleDeleteModal"
                >
                  <span class="an_t">{{
                    $t('library.deletemodal.cancel')
                  }}</span>
                </button>
                <button type="button" class="box_btn" @click="deleteNotes(id)">
                  <span class="an_t">{{
                    $t('library.deletemodal.delete')
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  UI_SHOW_SIDEBAR
  // UI_SELECT_BOOK,
  // UI_UNSELECT_BOOK
} from '@/store/types'

export default {
  name: 'MyNotes',
  data() {
    return {
      selected: false,
      isListMenuOpen: false,
      activeFilter: 1,
      showDeleteModal: false,
      // TEMP
      isSelectMode: false,
      isDeleteNoteModeEnabled: false
      // notes: [
      //   {
      //     id: 1,
      //     isBest: true,
      //     img: require('@/assets/images/cover/temp_book_cover.jpg'),
      //     noteAuthor: '홍길동'
      //   },
      //   {
      //     id: 2,
      //     isBest: false,
      //     img: require('@/assets/images/cover/temp_book_cover.jpg'),
      //     noteAuthor: '홍길동'
      //   }
      // ]
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentBookshelf',
      'getBookshelves',
      'isBookshelfLoading',
      'isSidebarOpen',
      // 'getSelectMode',
      // 'isDeleteNoteModeEnabled',
      'getSelectedLibraryBooks'
    ])
  },
  methods: {
    openSidebar() {
      this.$store.commit(UI_SHOW_SIDEBAR)
    },
    toggleListMenu() {
      this.isListMenuOpen = !this.isListMenuOpen
    },
    closeListMenu() {
      this.isListMenuOpen = false
    },
    startSelectMode() {
      this.isDeleteNoteModeEnabled = true
      this.isSelectMode = true
      // UI_ENABLE_DELETE_NOTE_MODE
    },
    endSelectMode() {
      this.isDeleteNoteModeEnabled = false
      this.isSelectMode = false
      // UI_DISABLE_DELETE_NOTE_MODE
    },
    toggleDeleteModal() {
      this.showDeleteModal = !this.showDeleteModal
    },
    // USE THIS IF MADE INTO A COMPONENT LATER
    filterNotes(value) {
      this.$emit('update:activeFilter', value)
    },
    selectThisBook() {
      this.selected = !this.selected

      // if (this.selected) {
      //   this.$store.commit(UI_SELECT_BOOK, this.book.id)
      // } else {
      //   this.$store.commit(UI_UNSELECT_BOOK, this.book.id)
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.location_wrap {
  @media (min-width: 1440px) {
    max-width: 100%;
    padding-left: 66px;
    padding-right: 66px;
  }
}

.library_option .btn .c_icon {
  width: 17px;
}
</style>
